//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('businessCo', {
//        templateUrl: 'views/components/views/businessCo/businessCo.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'businessCoService', 'logisticService', 'productSettingsService', 'typeaheadService', function ($stateParams, stateService, utilityService, translateService, modalService, businessCoService, logisticService, productSettingsService, typeaheadService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let businessCoNo = $stateParams.businessco_no;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                productSettingsButtons: [
//                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('productsettings') }
//                ],
//                edit: {},
//                selectListCountries: [],
//                selectListStockPlaces: [],
//                selectListStockPlacesCentral: [],
//                selectListProductSettings: [],
//                lockedSave: false
//            };

//            vm.style = {
//                logo: {
//                    img: {
//                        maxWidth: '100%',
//                        height: 'auto',
//                        maxHeight: '4.5rem',
//                        aspectRatio: 'auto',
//                    }
//                }
//            }

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await businessCoService.getEdit({ businessco_no: businessCoNo }))[0];
//            }

//            async function loadCountries() {
//                vm.model.selectListCountries = await logisticService.listCountries();
//            }

//            async function loadProductSettings() {
//                vm.model.selectListProductSettings = await productSettingsService.listProductSettings();
//            }

//            async function loadStockPlacesCentral() {
//                vm.model.selectListStockPlacesCentral = await logisticService.listStocks({ businessco_no: '0' });
//            }

//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;

//                return vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.edit.businessco_no });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value, id) {
//                switch (id) {
//                    case 'cust_name':
//                        vm.model.edit[id] = value;

//                        return typeaheadService.searchCustomer({
//                            cust_name: vm.model.edit[id] || '',
//                            filtertype: '',
//                            filtervalue: '',
//                            custtype: 'S',
//                            lastselect: 'SEARCH'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onTypeaheadSelected = function (item, id) {
//                switch (id) {
//                    case 'cust_name':
//                        if (item) {
//                            vm.model.edit.cust_no = item?.item_id ?? '0';
//                            vm.model.edit.cust_name = item?.item_name ?? '';
//                        } else {
//                            vm.onTypeaheadClear('cust_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onTypeaheadChanged = function (value, item, id) {
//                switch (id) {
//                    case 'cust_name':
//                        vm.model.edit.cust_name = value;

//                        if (value) {
//                            if (item?.item_id) {
//                                vm.model.edit.cust_no = item.item_id;
//                            }
//                        } else {
//                            vm.onTypeaheadClear('cust_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onTypeaheadClear = function (id) {
//                switch (id) {
//                    case 'cust_name':
//                        vm.model.edit.cust_no = '0';
//                        vm.model.edit.cust_name = '';
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CLEAR VALUE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                businessCoService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadCountries();
//                loadStockPlacesCentral();
//                loadProductSettings();
//                loadStockPlaces();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
